<template>
  <div class="calico-form-page">
    <div class="calico-form-container">
      <div class="calico-form-row">
        <CalicoForm
          v-slot="{ field, error }"
          name="text1"
          label="Label"
          rules="required"
        >
          <CalicoField
            v-model="text1"
            v-bind="field"
            :error="error"
            placeholder="Enter an amount"
          />
        </CalicoForm>
        <CalicoForm
          v-slot="{ field, error }"
          name="amount"
          label="Label"
          rules="required"
        >
          <CalicoField
            v-model="amount"
            v-bind="field"
            :error="error"
            placeholder="Enter an amount"
            disabled
          />
        </CalicoForm>
      </div>
      <div class="calico-form-row">
        <CalicoForm
          v-slot="{ field, error }"
          name="amount"
          label="Label"
          rules="required"
        >
          <CalicoField
            v-model="amount"
            v-bind="field"
            :error="error"
            placeholder="Enter an amount"
          />
        </CalicoForm>
        <CalicoForm
          v-slot="{ field, error }"
          name="amount"
          label="Label"
          message="Message"
        >
          <CalicoField
            v-model="amount"
            v-bind="field"
            :error="error"
            placeholder="Enter an amount"
          />
        </CalicoForm>
        <CalicoForm
          v-slot="{ field, error }"
          name="amount"
          label="Label"
          important="Important"
        >
          <CalicoField
            v-model="amount"
            v-bind="field"
            :error="error"
            placeholder="Enter an amount"
          />
        </CalicoForm>
        <CalicoForm
          v-slot="{ field, error }"
          name="amount"
          label="Label"
          important="Important"
          :tooltip="{
            header: 'Testing header',
            body: 'Testing body',
          }"
        >
          <CalicoField
            v-model="amount"
            v-bind="field"
            :error="error"
            placeholder="Enter an amount"
          />
        </CalicoForm>
      </div>
      <div class="calico-form-row">
        <CalicoForm
          v-slot="{ field, error }"
          name="checkbox1"
          label="Label"
          rules="required|email"
        >
          <CalicoCheckbox
            v-bind="field"
            v-model="checkbox1"
            value="checkbox1"
            :error="error"
          >
            Option 1
          </CalicoCheckbox>
          <CalicoCheckbox
            v-bind="field"
            v-model="checkbox2"
            value="checkbox2"
            :error="error"
          >
            Option 2
          </CalicoCheckbox>
          <CalicoCheckbox
            v-bind="field"
            v-model="checkbox3"
            value="checkbox3"
            :error="error"
          >
            Option 3
          </CalicoCheckbox>
        </CalicoForm>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import CalicoField from '@/components/calico/field/index.vue'
import CalicoCheckbox from '@/components/calico/checkbox/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'

export default {
  name: 'CalicoFieldPage',
  components: {
    CalicoField,
    CalicoForm,
    CalicoCheckbox
  },
  data () {
    return {
      amount: '',
      checkbox1: '',
      checkbox2: '',
      checkbox3: ''
    }
  },
  watch: {
    amount (value) {
      console.log(value)
    },
  }
}
</script>
<style lang="scss">
.calico-form-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-form-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;
    .calico-form-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
    }
  }
}
</style>
